import React, { ReactNode } from 'react';

interface IRenderDuringProps {
  showDuring: ReactNode;
  showDefault?: ReactNode;
  fromDate: Date;
  endDate: Date;
}

/**
 * @Note This is a COPY of the RenderDuring component from the compliance package.
 * The issues is that the compliance package is referencing the sales-common package.
 * If sales-common package refers the compliance package, it will cause a circular dependency.
 * To avoid this, we have copied the RenderDuring component here as a variant.
 *
 * The RenderDuring component is used to render a component based on the current date.
 * If the current date is between the fromDate and endDate, show the showDuring component.
 * Otherwise, show the showDefault component.
 * @param fromDate
 * @param endDate
 * @param showDuring
 * @param showDefault
 * @constructor <RenderDuring ...props />
 */
export const RenderDuring = ({
  fromDate,
  endDate,
  showDuring,
  showDefault,
}: IRenderDuringProps) => {
  const now = Date.now();

  if (now >= fromDate.getTime() && now < endDate.getTime()) {
    return <>{showDuring}</>;
  }
  if (showDefault) {
    return <>{showDefault}</>;
  }
  return null;
};
